import axios from "axios";
import { Global } from '../utils/general';

const API_URL = Global.url;

class GeneralService {
    getMoneda() {
        const ruta = `${API_URL}/LP/general/moneda`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    getCondicionPago() {
        const ruta = `${API_URL}/LP/general/payment-condition`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    getTipoComprobante() {
        const ruta = `${API_URL}/LP/general/voucher-type`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    getTipoEquipo() {
        const ruta = `${API_URL}/LP/general/tipo-equipo`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }
    getTipoEquipoMenorUIT() {
        const ruta = `${API_URL}/LP/general/tipo-equipo-menor`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    getTipoEquipoFull() {
        const ruta = `${API_URL}/LP/general/tipo-equipo-full`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    getEstadoEquipo() {
        const ruta = `${API_URL}/LP/general/estado-equipo`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    getVCentroCosto() {
        const ruta = `${API_URL}/LP/general/centroCosto`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    getTipoDocumento() {
        const ruta = `${API_URL}/LP/general/tipo-documento`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }
    getAreaOrganigrama() {
        const ruta = `${API_URL}/LP/general/jefes`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    getJefesTrabajador(id_trabajador) {
        const ruta = `${API_URL}/LP/general/jefes/${id_trabajador}`;
        return axios.get(ruta, {}).catch((error) => { return error; });
    }

    /*Agrupamiento by sede*/
    getEmpresas() {
        let ruta = `${API_URL}/LP/app/companies`;
        return axios
            .get(ruta, {})
            .catch((error) => {
                return error;
            });
    }

    getClientesByEmpresa(empresa_id) {
        let ruta = `${API_URL}/LP/app/client/${empresa_id}`;
        return axios
            .get(ruta, {

            })
            .catch((error) => {
                return error;
            });
    }

    getUnidadesByCliente(cliente_id) {
        let ruta = `${API_URL}/LP/app/units/${cliente_id}`;
        return axios
            .get(ruta, {

            })
            .catch((error) => {
                return error;
            });
    }

    getSedesByUnidad(unidad_id) {
        let ruta = `${API_URL}/LP/app/campus/${unidad_id}`;
        return axios
            .get(ruta, {

            })
            .catch((error) => {
                return error;
            });
    }
    getAreasBySede(sede_id) {
        let ruta = `${API_URL}/LP/app/areas/${sede_id}`;
        return axios
            .get(ruta, {

            })
            .catch((error) => {
                return error;
            });
    }

    /*Fin Agrupamiento by sede*/



}

export default new GeneralService();